import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const RedirectToHome = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/home", { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default RedirectToHome;
